/** @format */

import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import ContentTop from "../../components/ContentTop";
import ByRegion from "./ByRegion";
import ByDistrict from "./ByDistrict";

function Index() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  const [regionName, setRegionName] = useState("");

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari'>
          <li>Suvdan foydalanish</li>
        </ul>

        <ul className='content-top-right'>
          <input
            type='date'
            className='form-control form-control-sm'
            onChange={(e) => setLdate(e.target.value)}
            value={ldate}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <Routes>
          <Route
            path='/'
            element={<ByRegion date={date} setRegionName={setRegionName} />}
          />

          <Route
            path=':regionId'
            element={
              <ByDistrict
                date={date}
                setRegionName={setRegionName}
                regionName={regionName}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default Index;
